




















































import {Component, PropSync, Vue} from 'vue-property-decorator';
import DxPopup from 'devextreme-vue/popup';
import {confirm} from 'devextreme/ui/dialog';

import TableGrid from '@/components/TableGrid/grid.vue';
import DButton from '@/components/DButton/button.vue';
import BackupScheduleEditPopup from './edit-schedule-popup.vue';
import BackupScheduleService, {BackupSchedule} from '@/services/data/backup_schedule';
import {days} from '@/services/singleton-service';
import {
  formatDateTimeAsLocal, getLocalHoursAndMinutesAsString, correctDaysOfWeekByTimeZoneOnLoad
} from '@/utils/datetime';


@Component({
  name: 'BackupScheduler',
  components: {
    BackupScheduleEditPopup,
    DxPopup,
    TableGrid,
    DButton
  }
})
export default class extends Vue {
  @PropSync('visible') public syncVisible!: boolean;

  private service = BackupScheduleService;
  private tableColumns: any[] = [];

  protected mounted(): void {
    this.initColumns();
  }

  private initColumns(): void {
    this.tableColumns = [
      {
        dataField: 'id',
        dataType: 'string',
        visible: false
      },
      {
        calculateCellValue: this.formatDaysOfWeek,
        dataType: 'string',
        allowFiltering: false,
        allowSearch: false,
        allowSorting: true,
        caption: 'Дни недели'
      },
      {
        dataField: 'time',
        dataType: 'string',
        customizeText: this.formatUTCTimeAsLocal,
        caption: 'Время'
      },
      {
        dataField: 'run_once',
        dataType: 'boolean',
        caption: 'Однократно'
      },
      {
        dataField: 'have_run',
        dataType: 'date',
        customizeText: this.formatUTCDateTime,
        allowFiltering: false,
        allowSearch: false,
        allowSorting: true,
        caption: 'Последний запуск',
        alignment: 'center',
        width: '12em'
      },
      {
        type: 'buttons',
        buttons: [
          {
            icon: 'edit',
            hint: 'Редактировать',
            cssClass: 'dx-link__edit',
            visible: true,
            disabled: this.isScheduleReadOnly,
            onClick: this.onEdit
          },
          {
            icon: 'remove',
            hint: 'Удалить',
            cssClass: 'dx-link__delete',
            visible: true,
            onClick: this.onDelete
          }
        ]
      }
    ];
  }

  private onShowing(): void {
    this.onRefresh();
  }

  private onClose(): void {
    this.syncVisible = false;
  }

  private onClick(e: any): void {
    this.service.setCurrentRow(e.data);
  }

  private onDblClick(e: any): void {
    this.service.setCurrentRow(e.data);
    this.service.setEditMode(true);
    this.service.setEditPopupVisible(true);
  }

  private onAdd(): void {
    this.service.setEditMode(false);
    this.service.setEditPopupVisible(true);
  }

  private onEdit(e: any): void {
    this.service.setCurrentRow(e.row.data);
    this.service.setEditMode(true);
    this.service.setEditPopupVisible(true);
  }

  private onDelete(e: any): void {
    confirm('Расписание будет удалёно безвозвратно. Продолжать?', '')
      .then((answer: boolean) => {
        if (answer) {
          this.service.delete(e.row.data).then(() => {
            this.service.dataSource.reload().catch((reason: any) => { if (reason !== 'canceled') throw reason; });
          });
        }
      });
  }

  private onRefresh(): void {
    if (this.service.dataSource) {
      this.service.dataSource.reload().catch((reason: any) => { if (reason !== 'canceled') throw reason; });
    }
  }

  private formatDaysOfWeek(rowData: BackupSchedule): string {
    const aDate = new Date();
    const timeStr = rowData.time.split(':');
    aDate.setUTCHours(Number.parseInt(timeStr[0]), Number.parseInt(timeStr[1]));
    return correctDaysOfWeekByTimeZoneOnLoad(JSON.parse(rowData.days_of_week), aDate)
      .map((item: number) => {
        const day = days.find((d) => d.value === item);
        return day ? day.short_name : ''
      })
      .filter((item: string) => item.length > 0)
      .join(', ');
  }

  private formatUTCTimeAsLocal(e: any): string {
    if (!e.value) {
      return '';
    }
    const aDate = new Date();
    const timeStr = e.value.split(':');
    aDate.setUTCHours(Number.parseInt(timeStr[0]), Number.parseInt(timeStr[1]));
    return getLocalHoursAndMinutesAsString(aDate);
  }

  private formatUTCDateTime(e: any): string {
    if (!e.value) {
      return '';
    }
    return formatDateTimeAsLocal(e.value);
  }

  private isScheduleReadOnly(e: any): boolean {
    const schedule = e.row.data as BackupSchedule;
    return schedule.run_once && !!schedule.have_run;
  }
}
